import 'keen-slider/keen-slider.min.css'

const SubNavEmptyLink = () => {
  return (
    <li className="keen-slider__slide flex !overflow-visible px-1">
      <div className="m-auto mx-1.5 h-6 w-16 rounded bg-slate-200" />
    </li>
  )
}

export default SubNavEmptyLink
